import $ from "jquery";
import { setNewsList, setArticleList } from "#scripts/news";
import { getPageUrl } from "#scripts/general_functions";
import { mapPortal } from "#scripts/map";

export default () => {
	if (getPageUrl().contentid === "nyheter") {
		setNewsList();
	} else {
		let category = getPageUrl().contentid;
		category = category.split("/").pop();

		if (category.match(/^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i)) {
			setArticleList(category);
		} else if (category.substr(0, 30) === "https://psi.norge.no/los/tema/") {
			setArticleList(category);
		} else {
			category = `https://psi.norge.no/los/tema/${category}`;
			setArticleList(category);
		}
		// setArticleList(getPageUrl().contentid);
	}
};
